<template>
  <v-dialog v-model="model" max-width="520">
    <v-card class="k-card pa-4">
      <div class="text-h6 font-weight-bold mb-3">{{ $t("groups.createGroup") }}</div>

      <v-text-field
        v-model="name"
        :label="$t('groups.name')"
        outlined
        dense
        hide-details
      />

      <div class="d-flex justify-end mt-4">
        <v-btn text @click="model = false">{{ $t("common.cancel") }}</v-btn>
        <v-btn color="primary" depressed @click="submit" :disabled="!nameTrim">
          {{ $t("common.create") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: { value: Boolean },
  data: () => ({
    name: ""
  }),
  computed: {
    model: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); }
    },
    nameTrim() {
      return (this.name || "").trim();
    }
  },
  methods: {
    submit() {
      this.$emit("create", { name: this.nameTrim });
      this.name = "";
      this.model = false;
    }
  }
};
</script>
